module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Vue Masked Input")]), _vm._v(" "), _c('h3', [_vm._v("Dead simple masked input component for Vue.js 2.X")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h4', [_vm._v("Date: ")]), _vm._v(" "), _c('masked-input', {
    attrs: {
      "mask": "11 / 11 / 1111",
      "placeholder": "Date"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.date))]), _vm._v(" "), _c('p', {
    staticClass: "code"
  }, [_vm._v("\n    <masked-input v-model=\"date\" mask=\"11 / 11 / 1111\" placeholder=\"Date\" />\n  ")]), _vm._v(" "), _c('h4', [_vm._v("Phone: ")]), _vm._v(" "), _c('masked-input', {
    attrs: {
      "mask": "\\+\\1 (111) 1111-11",
      "placeholder": "Phone"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', {
    staticClass: "code"
  }, [_vm._v("\n    <masked-input v-model=\"phone\" mask=\"\\+\\1 (111) 1111-11\" placeholder=\"Phone\" />\n  ")]), _vm._v(" "), _c('h4', [_vm._v("Get a raw value: ")]), _vm._v(" "), _c('masked-input', {
    attrs: {
      "mask": "\\+\\1 (111) 1111-11",
      "placeholder": "Phone"
    },
    on: {
      "input": function($event) {
        _vm.rawVal = arguments[1]
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.rawVal))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h4', [_vm._v("Your own mask (hot re-mask available): ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userMask),
      expression: "userMask"
    }],
    attrs: {
      "placeholder": "Mask"
    },
    domProps: {
      "value": (_vm.userMask)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userMask = $event.target.value
      }
    }
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "mask": _vm.userMask,
      "placeholder": "Text"
    },
    model: {
      value: (_vm.userField),
      callback: function($$v) {
        _vm.userField = $$v
      },
      expression: "userField"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.userField))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Install ")]), _vm._v(" "), _c('p', {
    staticClass: "code"
  }, [_vm._v("\n    npm install vue-masked-input --save\n  ")]), _vm._v(" "), _c('h4', [_vm._v("Use")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/niksmr/vue-masked-input"
    }
  }, [_vm._v("GitHub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1 – number")]), _vm._v(" "), _c('li', [_vm._v("a – letter")]), _vm._v(" "), _c('li', [_vm._v("A – letter, forced to upper case when entered")]), _vm._v(" "), _c('li', [_vm._v("* – alphanumeric")]), _vm._v(" "), _c('li', [_vm._v("# – alphanumeric, forced to upper case when entered")]), _vm._v(" "), _c('li', [_vm._v("+ – any character")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "code"
  }, [_vm._v("\n    <masked-input mask=\"\\+\\1 (111) 1111-11\" placeholder=\"Phone\" "), _c('br'), _vm._v("  @input=\"rawVal = arguments[1]\" />\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "code"
  }, [_vm._v("\n    import MaskedInput from 'vue-masked-input'\n    "), _c('br'), _vm._v(" ... "), _c('br'), _vm._v("components: { "), _c('br'), _vm._v("  MaskedInput "), _c('br'), _vm._v("}\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Check "), _c('a', {
    attrs: {
      "href": "https://github.com/niksmr/vue-masked-input"
    }
  }, [_vm._v("GitHub")]), _vm._v(" for more")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5866d4c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 312
// module chunks = 0